module.exports = __webpack_public_path__ + "static/media/maolanshanicon.90b9dad6.png";